import { Controller } from '@hotwired/stimulus';

export default class extends Controller {
  static targets = ['fullAddress', 'address'];
  static values = { listenEvent: String };

  connect() {
    this._onTabChange = (event) => this.showAddress(event.detail.propertyIndex);
    window.addEventListener(this.listenEventValue, this._onTabChange);
  }

  disconnect() {
    window.removeEventListener(this.listenEventValue, this._onTabChange);
  }

  showAddress(tabIndex) {
    if (tabIndex <= 0 || this.addressTargets.length === 0) {
      this.fullAddressTarget.classList.remove('hidden');
      this.addressTargets.forEach((block) => block.classList.add('hidden'));
      return;
    }

    const clampedIndex = Math.min(tabIndex - 1, this.addressTargets.length - 1);

    this.fullAddressTarget.classList.add('hidden');
    this.addressTargets.forEach((block) => {
      block.classList.toggle('hidden', parseInt(block.dataset.propertyIndex, 10) !== clampedIndex);
    });
  }
}
